import { useTypedQuery } from "hooks";
import { LoginKeys } from "modules/Login/queryKeys";
import { ApiInstance } from "utils/Api";

const REFETCH_INTERVAL_MS = 1000;

type UseVerifyQRCodeQueryProps = {
  enabled: boolean;
  token?: string;
};

export const useVerifyQRCodeQuery = ({ enabled, token }: UseVerifyQRCodeQueryProps) =>
  useTypedQuery({
    queryKey: LoginKeys.session,
    queryFn: async ({ baseUrl }) => (await ApiInstance.post("/session/login/qr_code", { token }, baseUrl)).data,
    enabled: enabled && !!token,
    refetchInterval: REFETCH_INTERVAL_MS
  });
